import { render, staticRenderFns } from "./Roulette.vue?vue&type=template&id=764b5d02&scoped=true"
import script from "./Roulette.vue?vue&type=script&lang=js"
export * from "./Roulette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b5d02",
  null
  
)

export default component.exports